import cx from 'classnames'
import {ButtonGroupInput} from 'components/system/inputs/ButtonGroupInput'
import {Field} from 'react-final-form'
import {SelectOption} from 'types/basic'
import {ErrorMessage} from './ErrorMessage'

type Props = {
  options: SelectOption[]
  name: string
  className?: string
  id?: string
}

export const ButtonGroupInputField = ({name, className, options}: Props) => {
  return (
    <Field
      name={name}
      type="text"
      render={({input, meta}) => {
        const {active, dirty, error} = meta
        const showError = !active && dirty && error

        return (
          <div className={cx('flex flex-col', className)}>
            <ButtonGroupInput {...input} options={options} />
            {showError && <ErrorMessage>{error}</ErrorMessage>}
          </div>
        )
      }}
    />
  )
}
